module.exports = __webpack_public_path__ + "img/linkedin-square.b09d64a2.svg";